El pago puede realizarse a la cuenta 1081-646601 del Banco Económico.<br /><br/>
            <b>Datos de la cuenta:</b><br /><b>Nombre:</b>&nbsp; Andrés Miguel Ribera Méndez<br />
            <b>CI:</b>&nbsp; 6200200 SC<br />
            Caja de Ahorros en Bolivianos<br/>